import { render, staticRenderFns } from "./LandingVuetify.vue?vue&type=template&id=a42e1298&scoped=true"
import script from "./LandingVuetify.vue?vue&type=script&lang=js"
export * from "./LandingVuetify.vue?vue&type=script&lang=js"
import style0 from "./LandingVuetify.vue?vue&type=style&index=0&id=a42e1298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42e1298",
  null
  
)

export default component.exports